import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Currency, ExchangeRate } from '../../models/currency.interface';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-coin-switch',
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  templateUrl: './coin-switch.component.html',
  styleUrls: ['./coin-switch.component.scss'],
})
export class CoinSwitchComponent {
  @Input() currency: Currency = {
    symbol: 'S/',
    code: 'PEN',
  };

  @Input() tc: ExchangeRate = {
    currency: '',
    date: '',
    purchasePrice: 0,
    salesPrice: 0,
  };
  @Input() fromTrading: boolean = false;
  @Input() tradingType: 'BUY' | 'SELL' | null = null;
  @Input() showRefreshButton: boolean = false;
  @Input() compact: boolean = false;
  @Input() analyticsContext?: {
    zona?: string;
    subZona?: string;
    seccion?: string;
    pageTitle?: string;
  };
  @Output() currencyChange = new EventEmitter<any>();
  @Output() refreshWallets = new EventEmitter<void>();

  constructor(private analyticsService: AnalyticsService) {}

  changeCurrency() {
    const newCurrency =
      this.currency.symbol === '$'
        ? { symbol: 'S/', code: 'PEN' }
        : { symbol: '$', code: 'USD' };
    this.analyticsService.trackVirtualEvent({
      tipoElemento: 'Switch',
      zona: this.analyticsContext?.zona ?? 'Wallet',
      subZona: this.analyticsContext?.subZona ?? 'Inicio',
      seccion: this.analyticsContext?.seccion ?? 'Home',
      subSeccion: 'none',
      cta: newCurrency.code,
      pageTitle: this.analyticsContext?.pageTitle ?? 'Wallet - Inicio (Home)',
    });
    this.currency = newCurrency;
    this.currencyChange.emit(this.currency);
  }

  onContainerClick(event: Event) {
    const target = event.target as HTMLElement;
    if (
      target.closest('.currency-toggle__button') ||
      target.closest('.refresh-button')
    ) {
      return;
    }

    if (this.tc.purchasePrice && this.tc.salesPrice) {
      this.changeCurrency();
    }
  }

  onRefreshClick() {
    this.refreshWallets.emit();
  }
}
